import EmblaCarousel from "embla-carousel";

export function initEmblaCarousel(target) {
  target.querySelectorAll("[data-embla]").forEach((root) => {
    if (root.dataset.emblaInit) return;
    root.dataset.emblaInit = "true";

    const viewport = root.querySelector(".embla__viewport");
    if (!viewport) return;

    const embla = EmblaCarousel(viewport, {
      loop: false,
      slidesToScroll: "auto",
    });

    const prevBtn = root.querySelector("[data-embla-prev]");
    const nextBtn = root.querySelector("[data-embla-next]");
    if (prevBtn) prevBtn.addEventListener("click", () => embla.scrollPrev());
    if (nextBtn) nextBtn.addEventListener("click", () => embla.scrollNext());
  });
}
